import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SettingsCtx = createContext({
  settings: {},
  loading: true,
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/v1/site-settings")
      .then((r) => {
        if (r.data) {
          setSettings(r.data);
          
          if (r.data.favicon_url) {
            const url = r.data.favicon_url.startsWith('http') ? r.data.favicon_url : `${process.env.REACT_APP_BACKEND_URL || ''}${r.data.favicon_url}`;
            let link = document.getElementById("dynamic-favicon");
            if (link) {
              link.parentNode.removeChild(link);
            } else {
              link = document.querySelector("link[rel*='icon']");
              if (link) link.parentNode.removeChild(link);
            }
            link = document.createElement('link');
            link.id = 'dynamic-favicon';
            link.rel = 'shortcut icon';
            link.href = url;
            document.getElementsByTagName('head')[0].appendChild(link);
          }

          // Optionally update the initial loader logo in the DOM if it's still there
          if (r.data.logo_url) {
            const initialLogo = document.querySelector('.initial-logo');
            if (initialLogo) {
              initialLogo.src = r.data.logo_url.startsWith('http') ? r.data.logo_url : `${process.env.REACT_APP_BACKEND_URL || ''}${r.data.logo_url}`;
            }
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <SettingsCtx.Provider value={{ settings, loading }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
